import UiVideo from 'pages/Ui/UiVideo';
import React, { useState, useEffect, useMemo, useRef, useCallback, use } from 'react';
import { useSelector } from 'react-redux';
import { Card, CardBody, Col, Dropdown, DropdownItem, DropdownMenu, DropdownToggle, Row } from 'reactstrap';
import moment from "moment";
import toastr from "toastr";
import img from '../../assets/images/download.jpeg';
import Rtsp from './rtsp';
import { useDispatch } from 'react-redux';
import { getCameraActive, getDetailData, getsnapshotData, getTableData } from 'store/actions';
import { get } from "../../helpers/api_helper";
import Hls from 'hls.js';


function PlayerCard({ details, externalMediaUrl }) {

  const dispatch = useDispatch();
  const [selectedCam, setSelectedCam] = useState(null);
  const [singlebtn, setSinglebtn] = useState(false);
  const [playerSrc, setPlayerSrc] = useState(null);
  const permission = (useSelector(state => state.Login?.userData?.data?.roleType?.[0]?.permission));
  const [role, setRole] = useState([]);
  const liveCameras = useSelector(state => state.Live_Camera_Data?.data);
  const [liveStatus, setliveStatus] = useState(false);
  const tableData = useSelector(state => state.Data_Table?.data);
  const user = useSelector(state => state.Login.user);
  const sid = user?.sessionID;
  const startDate = useSelector(state => state.Active_Store?.dates?.startDate);
  const endDate = useSelector(state => state.Active_Store?.dates?.endDate);
  const macAddress = useSelector(state => state.Active_Store?.macAddress);
  const [isLoading, setIsLoading] = useState(false);
  const [loadingMsg, setLoadingMsg] = useState("");
  const [indicatorPosition, setIndicatorPosition] = useState(0); // percentage
  const [timelineViewMode, setTimelineViewMode] = useState('24/7'); // '24/7' or 'hoursPlayed'
  const [isDragging, setIsDragging] = useState(false);
  const [showTooltip, setShowTooltip] = useState(false);
  const [zoomLevel, setZoomLevel] = useState(1); // 1 = 100%, 2 = 200%, etc.
  const [panOffset, setPanOffset] = useState(0); // percentage offset for panning
  const [playbackSpeed, setPlaybackSpeed] = useState(1);
  const [bufferedPercent, setBufferedPercent] = useState(0);
  const [currentPlaybackPercent, setCurrentPlaybackPercent] = useState(0);
  const [hoveredSegment, setHoveredSegment] = useState(null);
  const [hoverPosition, setHoverPosition] = useState({ x: 0, y: 0 });
  const [currentlyPlayingSegment, setCurrentlyPlayingSegment] = useState(null);
  const [preloadedUrls, setPreloadedUrls] = useState({}); // Cache for preloaded segment URLs
  const timelineRef = useRef(null);
  const timelineContainerRef = useRef(null);
  const isPanDragging = useRef(false);
  const panDragStartX = useRef(0);
  const panDragStartOffset = useRef(0);
  const videoRef = useRef(null);
  const pollingIntervalRef = useRef(null); // Track polling interval for cleanup
  const [showDataInTable, setShowDataInTable] = useState([]);
  const routeName = useSelector(state => state.Route_List?.activeRoute);
  const regex = new RegExp("[()]", "g");
  let route = routeName.replace(regex, "").trim().split(" ")[0];


  function compare(a, b) {
    let dateA = moment(a.FileDetails.FileDate);
    let dateB = moment(b.FileDetails.FileDate);
    if (dateA < dateB) {
      return -1;
    }
    if (dateA > dateB) {
      return 1;
    }
    return 0;
  }

  // Handle external media URL from Tasks component
  useEffect(() => {
    if (externalMediaUrl) {
      // Pause any playing video
      if (videoRef.current) {
        videoRef.current.pause();
      }
      setPlayerSrc(externalMediaUrl);
      setIsLoading(false);
      setLoadingMsg("");
    }
  }, [externalMediaUrl]);




  useEffect(() => {
    if (selectedCam) {
      console.log("selectedCam", selectedCam);
      let activeCamera = selectedCam?.Cam;
      let macAddress = selectedCam?.mac;
      let liveStatus = selectedCam?.live === 1 ? true : false;
      dispatch(getCameraActive({ activeCamera, macAddress, liveStatus }));
      console.log("macAddress", macAddress);
    }
  }, [selectedCam, dispatch])

  useEffect(() => {
    let noData = [];
    // setSelectedAction("0");
    setShowDataInTable(noData);
    console.log(showDataInTable);
    let queryParam = {
      "sid": sid,
      "date": startDate,
      "camid": macAddress,
      "rid": 0,
      "enddate": endDate,
      "payload": ""
    }

    if (macAddress) {
      dispatch(getTableData(queryParam, (response) => {

        if (response.OK) {

          const sortedData = response.OK.data.sort(compare);
          const showDataInTable = getDataToShowInTable(sortedData);
          setShowDataInTable(showDataInTable);
          console.log("Show Data ", showDataInTable);

        } else {
          setShowDataInTable(noData);
        }
        console.log("Show Data ", showDataInTable);
        console.log("Api response", response);
      }))
    } else {
      console.log("No mac Address");
    }

  }, [macAddress, sid, startDate, endDate])


  const hlsRef = useRef(null); // Keep track of the Hls instance

  // const handleRefreshStream = () => {
  //   if (!playerSrc || !videoRef.current) return;

  //   // Hard reset HLS
  //   if (hlsRef.current) {
  //     hlsRef.current.destroy();
  //   }

  //   // Re-initialize for the exact same URL
  //   if (Hls.isSupported()) {
  //     const hls = new Hls();
  //     hlsRef.current = hls;
  //     hls.loadSource(playerSrc);
  //     hls.attachMedia(videoRef.current);
  //     hls.on(Hls.Events.MANIFEST_PARSED, () => videoRef.current.play());
  //   }
  // };


  const setColor = (status) => {
    if (status == 'O') return "orange";
    if (status == 'E') return "red";
    if (status == 'R') return "green";
    if (status == 'D') return "skyblue";
  };




  const timelineData = useMemo(() => {
    if (!tableData || !Array.isArray(tableData)) return [];

    let start = startDate ? moment(startDate).startOf('day') : moment().startOf('day');
    let end = endDate ? moment(endDate).endOf('day') : start.clone().endOf('day');

    // Ensure end is not before start
    if (end.isBefore(start)) end = start.clone().endOf('day');

    const totalDuration = end.diff(start);
    if (totalDuration <= 0) return [];

    // Sort by date
    const sortedData = [...tableData]
      .filter(item => item?.FileDetails?.File)
      .sort((a, b) => {
        let dateA = moment(a.FileDetails.FileDate);
        let dateB = moment(b.FileDetails.FileDate);
        return dateA - dateB;
      });

    const segments = [];

    sortedData.forEach(item => {
      const filename = item.FileDetails.File;
      const format = "[P]YYMMDD_HHmmss";
      const parsedDate = moment(filename, format);
      const time = moment(parsedDate);
      const status = item.FileDetails.Status;
      const durationInMin = item.FileDetails.DurationInMin;


      // Filter out data outside bounds
      if (!time.isBetween(start, end, null, '[]')) return;

      let lastTime = time.clone();
      if (durationInMin === 0) {
        lastTime.add(59, 'seconds');
      } else {
        lastTime.add(durationInMin, 'minutes');
      }

      segments.push({
        start: time,
        status,
        lastTime,
        filename,
        fileDate: time
      });
    });

    return segments.map(seg => {
      const offset = seg.start.diff(start);
      const left = (offset / totalDuration) * 100;
      const segmentDurationMs = seg.lastTime.diff(seg.start);
      const width = (segmentDurationMs / totalDuration) * 100;
      return {
        left,
        width,
        status: seg.status,
        start: seg.start,
        end: seg.lastTime,
        filename: seg.filename,
        fileDate: seg.fileDate
      };
    });
  }, [tableData, startDate, endDate]);

  // Hours Played mode: compress segments to remove dead time
  const hoursPlayedTimelineData = useMemo(() => {
    if (!timelineData || timelineData.length === 0) return { segments: [], totalWidthSum: 0 };

    const totalWidthSum = timelineData.reduce((sum, seg) => sum + seg.width, 0);
    if (totalWidthSum <= 0) return { segments: [], totalWidthSum: 0 };

    let runningLeft = 0;
    const segments = timelineData.map(seg => {
      const normalizedWidth = (seg.width / totalWidthSum) * 100;
      const mapped = {
        ...seg,
        originalLeft: seg.left,
        originalWidth: seg.width,
        left: runningLeft,
        width: normalizedWidth,
      };
      runningLeft += normalizedWidth;
      return mapped;
    });

    return { segments, totalWidthSum };
  }, [timelineData]);

  // Hours Played mode: generate time markers from footage timestamps
  const hoursPlayedTimeMarkers = useMemo(() => {
    const { segments } = hoursPlayedTimelineData;
    if (!segments || segments.length === 0) return [];

    const markers = [];
    segments.forEach(seg => {
      markers.push({
        position: seg.left,
        label: seg.start.format('HH:mm'),
        date: seg.start.format('DD MMM'),
      });
    });
    // Add a final marker for the last segment's end
    const lastSeg = segments[segments.length - 1];
    markers.push({
      position: lastSeg.left + lastSeg.width,
      label: lastSeg.end.clone().add(1, 'minutes').format('HH:mm'),
      date: lastSeg.end.format('DD MMM'),
    });
    return markers;
  }, [hoursPlayedTimelineData]);

  // Calculate zoom information based on actual time ranges
  const zoomInfo = useMemo(() => {
    let totalDuration = 0; // Total hours in the range

    if (timelineViewMode === 'hoursPlayed') {
      if (timelineData && timelineData.length > 0) {
        const firstStart = timelineData[0].start;
        const lastEnd = timelineData[timelineData.length - 1].end;
        totalDuration = lastEnd.diff(firstStart, 'hours', true);
      }
    } else {
      const start = startDate ? moment(startDate).startOf('day') : moment().startOf('day');
      const end = endDate ? moment(endDate).endOf('day') : start.clone().endOf('day');
      totalDuration = end.diff(start, 'hours', true);
    }

    // Ensure it's at least a small fraction to avoid division by zero
    totalDuration = Math.max(0.01, totalDuration);

    // Calculate the current view window in hours
    const viewWindowHours = totalDuration / zoomLevel;

    // Determine the display unit and value
    let unit = 'hour';
    let value = viewWindowHours;

    if (viewWindowHours >= 24) {
      unit = 'day';
      value = viewWindowHours / 24;
    } else if (viewWindowHours < 1) {
      unit = 'min';
      value = viewWindowHours * 60;
    }

    // Format the value nicely
    const displayValue = value >= 10 ? Math.round(value) : value.toFixed(1);

    return {
      totalHours: totalDuration,
      viewWindowHours,
      unit,
      displayValue,
      displayText: `${displayValue} ${unit}${parseFloat(displayValue) !== 1 ? 's' : ''}`
    };
  }, [startDate, endDate, zoomLevel, timelineViewMode, timelineData]);

  // Generate time markers based on zoom level
  const timeMarkers = useMemo(() => {
    const markers = [];
    const start = startDate ? moment(startDate).startOf('day') : moment().startOf('day');
    const end = endDate ? moment(endDate).endOf('day') : start.clone().endOf('day');
    const totalDuration = end.diff(start);

    if (totalDuration <= 0) return markers;

    // Determine interval based on view window hours
    const viewWindowHours = zoomInfo.viewWindowHours;
    let intervalHours = 6; // Default: show every 6 hours

    if (viewWindowHours <= 2) intervalHours = 0.25; // 15 minutes
    else if (viewWindowHours <= 6) intervalHours = 0.5; // 30 minutes
    else if (viewWindowHours <= 12) intervalHours = 1; // 1 hour
    else if (viewWindowHours <= 24) intervalHours = 2; // 2 hours
    else if (viewWindowHours <= 48) intervalHours = 3; // 3 hours
    else if (viewWindowHours <= 72) intervalHours = 6; // 6 hours
    else intervalHours = 12; // 12 hours

    let current = start.clone();
    while (current.isSameOrBefore(end)) {
      const offset = current.diff(start);
      const position = (offset / totalDuration) * 100;
      markers.push({
        position,
        label: current.format('HH:mm'),
        date: current.format('DD MMM')
      });
      current.add(intervalHours, 'hours');
    }
    return markers;
  }, [startDate, endDate, zoomLevel, zoomInfo]);

  // Derived selectors for the active mode
  const activeTimelineData = timelineViewMode === 'hoursPlayed'
    ? hoursPlayedTimelineData.segments
    : timelineData;

  const activeTimeMarkers = timelineViewMode === 'hoursPlayed'
    ? hoursPlayedTimeMarkers
    : timeMarkers;

  // Compute the current segment at the indicator position
  const currentIndicatorSegment = useMemo(() => {
    if (!activeTimelineData || activeTimelineData.length === 0) return null;

    for (const seg of activeTimelineData) {
      const segEnd = seg.left + seg.width;
      if (indicatorPosition >= seg.left && indicatorPosition <= segEnd) {
        return seg;
      }
    }
    return null;
  }, [activeTimelineData, indicatorPosition]);

  /**
   * Helper function to fetch segment URL from API
   * Returns { url, message } object
   */
  const fetchSegmentUrl = useCallback(async (seg, skipCache = false, isPreload = false) => {
    if (!seg || !seg.filename || !selectedCam?.Cam) return { url: null, message: null };

    const segmentKey = `${seg.filename}_${seg.fileDate.format('YYYYMMDD')}`;

    // Check if already cached (unless skipCache is true)
    if (!skipCache && preloadedUrls[segmentKey]) {
      console.log('Using cached URL for:', segmentKey);
      return { url: preloadedUrls[segmentKey], message: null };
    }

    const dateStr = seg.fileDate.format('YYYYMMDD');
    const apiPath = `apiv2/apis/H264Playback2.php?sid=${encodeURIComponent(sid)}&camid=${encodeURIComponent(selectedCam.Cam)}&fid=${encodeURIComponent(seg.filename)}&date=${encodeURIComponent(dateStr)}`;

    try {
      const data = await get(apiPath);

      if (data?.error) {
        const errMsg = typeof data.error === 'string'
          ? data.error
          : (data.error?.msg || "Failed to convert video");
        if (!isPreload) toastr.error(errMsg);
        return { url: null, message: errMsg, stopPolling: true };
      }

      const code = data?.OK?.code;
      if (code === 5) {
        return { url: null, message: data.OK.msg };
      }
      const hlsUrl = Array.isArray(data?.OK?.data)
        ? data.OK.data[1]?.hls_url
        : data?.OK?.data?.hls_url;
      if (hlsUrl) {
        setPreloadedUrls(prev => ({
          ...prev,
          [segmentKey]: hlsUrl
        }));
        console.log('Fetched and cached URL for:', segmentKey);
        return { url: hlsUrl, message: data?.OK?.msg };
      } else {
        return { url: null, message: data?.OK?.msg || "Processing..." };
      }

    } catch (error) {
      const errMsg = error?.response?.data?.error
        || error?.response?.data?.OK?.msg
        || error?.message
        || "Failed to fetch video URL";
      console.error('Error fetching segment URL:', error);
      if (!isPreload) toastr.error(typeof errMsg === 'string' ? errMsg : "Failed to fetch video URL");
      return { url: null, message: errMsg, stopPolling: true };
    }
  }, [selectedCam, sid]);

  /**
   * Poll for segment URL until it's available
   * Polls every 3 seconds, max 20 attempts (1 minute)
   */
  const pollForSegmentUrl = useCallback((seg, onUrlReady, onStatusUpdate) => {
    // Clear any existing polling
    if (pollingIntervalRef.current) {
      clearInterval(pollingIntervalRef.current);
      pollingIntervalRef.current = null;
    }

    let attemptCount = 0;
    const maxAttempts = 10;
    const pollInterval = 10000; // 10 seconds

    console.log('Starting polling for segment:', seg.filename);

    const poll = async () => {
      attemptCount++;
      console.log(`Polling attempt ${attemptCount}/${maxAttempts} for ${seg.filename}`);

      const result = await fetchSegmentUrl(seg, true); // skipCache = true for fresh data

      if (result.url) {
        // URL is ready!
        console.log('Polling successful! URL ready:', seg.filename);
        clearInterval(pollingIntervalRef.current);
        pollingIntervalRef.current = null;
        onUrlReady(result.url);
      } else if (result.stopPolling) {
        // Hard error — stop polling immediately
        clearInterval(pollingIntervalRef.current);
        pollingIntervalRef.current = null;
        onStatusUpdate(result.message || "Error processing video", true);
      } else if (attemptCount >= maxAttempts) {
        // Max attempts reached
        console.log('Polling timeout after', maxAttempts, 'attempts');
        clearInterval(pollingIntervalRef.current);
        pollingIntervalRef.current = null;
        onStatusUpdate('Timeout: Video not ready. Please try again later.');
      } else {
        // Update status message
        if (result.message) {
          onStatusUpdate(result.message);
        }
      }
    };

    // Start polling immediately, then every interval
    poll();
    pollingIntervalRef.current = setInterval(poll, pollInterval);
  }, [fetchSegmentUrl]);

  /**
   * Get segments immediately before and after the current segment
   */
  const getAdjacentSegments = useCallback((currentSeg) => {
    if (!currentSeg || !activeTimelineData || activeTimelineData.length === 0) return [];

    const currentIndex = activeTimelineData.findIndex(
      s => s.filename === currentSeg.filename &&
        s.start.isSame(currentSeg.start)
    );

    if (currentIndex === -1) return [];

    const adjacent = [];
    // One segment before
    if (currentIndex > 0) {
      const prev = activeTimelineData[currentIndex - 1];
      if (prev.status === 'R') adjacent.push(prev);
    }
    // One segment after
    if (currentIndex < activeTimelineData.length - 1) {
      const next = activeTimelineData[currentIndex + 1];
      if (next.status === 'R') adjacent.push(next);
    }

    return adjacent;
  }, [activeTimelineData]);

  /**
   * Preload one segment before and after the current segment
   * Note: Don't do polling for these background requests
   */
  const preloadNearbySegments = useCallback(async (currentSeg) => {
    const nearbySegments = getAdjacentSegments(currentSeg);

    console.log(`Preloading ${nearbySegments.length} adjacent segments of ${currentSeg.start.format('HH:mm')}`);

    if (nearbySegments.length > 0) {
      console.log('Segments to preload:', nearbySegments.map(s => ({
        time: `${s.start.format('HH:mm')}-${s.end.format('HH:mm')}`,
        filename: s.filename
      })));
    }

    // Fetch URLs for nearby segments in parallel
    // fetchSegmentUrl already checks cache, and we don't call pollForSegmentUrl here
    // Pass skipCache=false and isPreload=true to suppress toasts
    const fetchPromises = nearbySegments.map(seg => fetchSegmentUrl(seg, false, true));
    const results = await Promise.allSettled(fetchPromises);

    const successCount = results.filter(r => r.status === 'fulfilled' && r.value?.url).length;
    console.log(`Preloaded ${successCount}/${nearbySegments.length} segments successfully (no polling)`);
  }, [getAdjacentSegments, fetchSegmentUrl]);

  /* 
   * Handle segment click (play video)
   * Moved here to be accessible by other hooks
   */
  const handleSegmentClick = useCallback(async (seg) => {
    console.log(seg);

    // Move indicator to this segment's position
    setIndicatorPosition(seg.left);

    if (seg.status !== 'R') {
      if (seg.status === 'O') {
        toastr.warning("File is Pending");
        setPlayerSrc(null);
      } else if (seg.status === 'E') {
        toastr.error("File has Error");
        setPlayerSrc(null);
      } else {
        toastr.error("Unknown reason, please contact admin");
        setPlayerSrc(null);
      }
      return;
    }
    if (!seg.filename || !selectedCam?.Cam) return;

    // Clear any existing polling
    if (pollingIntervalRef.current) {
      clearInterval(pollingIntervalRef.current);
      pollingIntervalRef.current = null;
    }

    setIsLoading(true);
    setLoadingMsg("Loading...");
    setCurrentlyPlayingSegment(seg);

    try {
      // Try to get URL from cache or fetch it
      const result = await fetchSegmentUrl(seg);

      console.log("URL 111111", result.url)

      if (result.url) {
        // URL is available immediately
        setPlayerSrc({ url: result.url, t: Date.now() });
        setIsLoading(false);
        setLoadingMsg("");

        // Preload nearby segments in the background (don't await)
        preloadNearbySegments(seg).catch(err =>
          console.error('Error preloading nearby segments:', err)
        );
      } else if (result.stopPolling) {
        // Hard error (e.g. "File copy failed") — do NOT poll, just stop
        setIsLoading(false);
        setLoadingMsg("");
        setPlayerSrc(null);
        setCurrentlyPlayingSegment(null);
      } else {
        // URL not ready yet - start polling
        const initialMsg = result.message || "Processing video... Please wait.";
        setLoadingMsg(initialMsg);

        pollForSegmentUrl(
          seg,
          // onUrlReady callback
          (url) => {
            setPlayerSrc({ url: url, t: Date.now() });
            setIsLoading(false);
            setLoadingMsg("");

            // Preload nearby segments after successful load
            preloadNearbySegments(seg).catch(err =>
              console.error('Error preloading nearby segments:', err)
            );
          },
          // onStatusUpdate callback
          (message, isFinal) => {
            if (isFinal) {
              setIsLoading(false);
              setLoadingMsg("");
              setPlayerSrc(null);
            } else {
              setLoadingMsg(message);
              if (message.includes('Timeout')) {
                setIsLoading(false);
              }
            }
          }
        );
      }
    } catch (error) {
      console.error("Error fetching playback url", error);
      setIsLoading(false);
      setLoadingMsg("Error loading video");
    }
  }, [selectedCam, sid, fetchSegmentUrl, preloadNearbySegments, pollForSegmentUrl]);

  // Handle timeline click for scrubbing
  const handleTimelineClick = (e) => {
    if (isDragging) return;
    if (!timelineRef.current) return;

    const rect = timelineRef.current.getBoundingClientRect();
    let clickPosition = ((e.clientX - rect.left) / rect.width) * 100;

    // Adjust for zoom and pan
    clickPosition = (clickPosition / zoomLevel) + panOffset;
    clickPosition = Math.max(0, Math.min(100, clickPosition));

    setIndicatorPosition(clickPosition);

    // Find and play the segment at this position (use active data)
    const segment = findSegmentAtPosition(clickPosition);
    if (segment) {
      handleSegmentClick(segment);
    } else {
      // No segment found - stop video and show snapshot
      if (videoRef.current) {
        videoRef.current.pause();
        videoRef.current.currentTime = 0;
      }
      setPlayerSrc(null);
      setCurrentlyPlayingSegment(null);
      setIsLoading(false);
      console.log('No recording at this position - showing snapshot');
    }
  };

  // Calculate max zoom level based on 1 hour minimum view
  const maxZoomLevel = useMemo(() => {
    let totalHours = 0;
    if (timelineViewMode === 'hoursPlayed') {
      if (timelineData && timelineData.length > 0) {
        const firstStart = timelineData[0].start;
        const lastEnd = timelineData[timelineData.length - 1].end;
        totalHours = lastEnd.diff(firstStart, 'hours', true);
      }
    } else {
      const start = startDate ? moment(startDate).startOf('day') : moment().startOf('day');
      const end = endDate ? moment(endDate).endOf('day') : start.clone().endOf('day');
      totalHours = end.diff(start, 'hours', true);
    }

    return Math.max(1, totalHours); // At least 1x zoom
  }, [startDate, endDate, timelineViewMode, timelineData]);

  // Handle zoom
  const handleZoomIn = () => {
    const newZoom = Math.min(zoomLevel * 2, maxZoomLevel);
    if (newZoom !== zoomLevel) {
      const maxPan = 100 - (100 / newZoom);
      let newPan = indicatorPosition - (indicatorPosition - panOffset) * (zoomLevel / newZoom);
      setPanOffset(Math.max(0, Math.min(newPan, maxPan)));
      setZoomLevel(newZoom);
    }
  };

  const handleZoomOut = () => {
    const newZoom = Math.max(zoomLevel / 2, 1);
    if (newZoom !== zoomLevel) {
      const maxPan = 100 - (100 / newZoom);
      let newPan = indicatorPosition - (indicatorPosition - panOffset) * (zoomLevel / newZoom);
      setPanOffset(Math.max(0, Math.min(newPan, maxPan)));
      setZoomLevel(newZoom);
    }
  };

  const handleResetZoom = () => {
    setZoomLevel(1);
    setPanOffset(0);
  };

  // Handle pan
  const handlePanLeft = () => {
    setPanOffset(prev => Math.max(prev - (10 / zoomLevel), 0));
  };

  const handlePanRight = () => {
    const maxPan = 100 - (100 / zoomLevel);
    setPanOffset(prev => Math.min(prev + (10 / zoomLevel), maxPan));
  };

  // Handle drag-to-pan on the timeline container
  const handleTimelinePanStart = useCallback((e) => {
    // Only start pan-drag if zoomed in and not clicking on the indicator
    if (zoomLevel <= 1) return;
    // Don't start pan drag if clicking on a segment or the indicator handle
    if (e.target.closest('[data-indicator]') || e.target.closest('[data-segment]')) return;

    isPanDragging.current = true;
    panDragStartX.current = e.clientX;
    panDragStartOffset.current = panOffset;
    e.currentTarget.style.cursor = 'grabbing';
    e.preventDefault(); // Prevent text selection while drag-panning
  }, [zoomLevel, panOffset]);

  const handleTimelinePanMove = useCallback((e) => {
    if (!isPanDragging.current || !timelineContainerRef.current) return;

    const containerWidth = timelineContainerRef.current.getBoundingClientRect().width;
    const deltaX = e.clientX - panDragStartX.current;
    // Convert pixel delta to percentage of the full (zoomed) timeline
    // Moving mouse right -> pan left (show earlier content), so negative direction
    const deltaPct = -(deltaX / containerWidth) * 100;

    const maxPan = 100 - (100 / zoomLevel);
    const newPan = Math.max(0, Math.min(panDragStartOffset.current + deltaPct, maxPan));
    setPanOffset(newPan);
  }, [zoomLevel]);

  const handleTimelinePanEnd = useCallback(() => {
    if (isPanDragging.current) {
      isPanDragging.current = false;
      if (timelineContainerRef.current) {
        timelineContainerRef.current.style.cursor = zoomLevel > 1 ? 'grab' : 'pointer';
      }
    }
  }, [zoomLevel]);

  // Mouse wheel pan on timeline
  const handleTimelineWheel = useCallback((e) => {
    if (zoomLevel <= 1) return;
    e.preventDefault();

    const maxPan = 100 - (100 / zoomLevel);
    // Use deltaX for horizontal scroll, or deltaY if no horizontal (e.g. regular mouse wheel)
    const delta = Math.abs(e.deltaX) > Math.abs(e.deltaY) ? e.deltaX : e.deltaY;
    const panStep = (5 / zoomLevel); // percentage to move per scroll tick
    const newPan = panOffset + (delta > 0 ? panStep : -panStep);
    setPanOffset(Math.max(0, Math.min(newPan, maxPan)));
  }, [zoomLevel, panOffset]);

  // Add/remove document-level listeners for pan dragging
  useEffect(() => {
    const handleDocPanMove = (e) => handleTimelinePanMove(e);
    const handleDocPanEnd = () => handleTimelinePanEnd();

    document.addEventListener('mousemove', handleDocPanMove);
    document.addEventListener('mouseup', handleDocPanEnd);
    return () => {
      document.removeEventListener('mousemove', handleDocPanMove);
      document.removeEventListener('mouseup', handleDocPanEnd);
    };
  }, [handleTimelinePanMove, handleTimelinePanEnd]);

  // Attach wheel listener with passive: false to allow preventDefault
  useEffect(() => {
    const container = timelineContainerRef.current;
    if (!container) return;
    const handler = (e) => handleTimelineWheel(e);
    container.addEventListener('wheel', handler, { passive: false });
    return () => container.removeEventListener('wheel', handler);
  }, [handleTimelineWheel]);

  // Handle playback speed change
  const handleSpeedChange = (speed) => {
    setPlaybackSpeed(speed);
    if (videoRef.current) {
      videoRef.current.playbackRate = speed;
    }
  };

  // Update buffered and playback progress from video
  useEffect(() => {
    const video = videoRef.current;
    if (!video) return;

    const updateProgress = () => {
      if (video.duration) {
        setCurrentPlaybackPercent((video.currentTime / video.duration) * 100);
      }

      // Update indicator position based on video progress
      if (video.duration && currentlyPlayingSegment && !isDragging) {
        if (timelineViewMode === 'hoursPlayed') {
          // In Hours Played mode: find the matching compressed segment
          const compressedSeg = hoursPlayedTimelineData.segments.find(
            s => s.filename === currentlyPlayingSegment.filename &&
              s.start.isSame(currentlyPlayingSegment.start)
          );
          if (compressedSeg) {
            const segDurationMs = compressedSeg.end.diff(compressedSeg.start);
            const videoProgressWithinSeg = segDurationMs > 0
              ? (video.currentTime * 1000) / segDurationMs
              : 0;
            const newPos = compressedSeg.left + (videoProgressWithinSeg * compressedSeg.width);
            setIndicatorPosition(Math.min(newPos, compressedSeg.left + compressedSeg.width));
          }
        } else {
          // 24/7 mode: original logic
          let start = startDate ? moment(startDate).startOf('day') : moment().startOf('day');
          let end = endDate ? moment(endDate).endOf('day') : start.clone().endOf('day');
          if (end.isBefore(start)) end = start.clone().endOf('day');

          const totalDuration = end.diff(start); // milliseconds

          if (totalDuration > 0) {
            const videoProgressPercent = ((video.currentTime * 1000) / totalDuration) * 100;
            const newIndicatorPosition = currentlyPlayingSegment.left + videoProgressPercent;
            setIndicatorPosition(newIndicatorPosition);
          }
        }
      }
    };

    const updateBuffer = () => {
      if (video.buffered.length > 0 && video.duration) {
        setBufferedPercent((video.buffered.end(video.buffered.length - 1) / video.duration) * 100);
      }
    };

    const handleEnded = () => {
      // Find the current segment index in the active view's data
      if (currentlyPlayingSegment && activeTimelineData) {
        const currentIndex = activeTimelineData.findIndex(
          s => s.filename === currentlyPlayingSegment.filename &&
            s.start.isSame(currentlyPlayingSegment.start)
        );

        // If there is a next segment, play it
        if (currentIndex !== -1 && currentIndex < activeTimelineData.length - 1) {
          const nextSeg = activeTimelineData[currentIndex + 1];
          handleSegmentClick(nextSeg);
        }
      }
    };

    video.addEventListener('timeupdate', updateProgress);
    video.addEventListener('progress', updateBuffer);
    video.addEventListener('ended', handleEnded);

    return () => {
      video.removeEventListener('timeupdate', updateProgress);
      video.removeEventListener('progress', updateBuffer);
      video.removeEventListener('ended', handleEnded);
    };
  }, [playerSrc, currentlyPlayingSegment, isDragging, activeTimelineData, timelineViewMode, hoursPlayedTimelineData, handleSegmentClick, startDate, endDate]);


  useEffect(() => {
    if (permission !== null) {
      setRole(permission.split(",").map(Number));
    }
  }, [])

  useEffect(() => {
    if (details?.RouteDetail?.Cam_Details?.length > 0) {
      // If we already have a selected camera, try to find it in the new details to maintain selection
      if (selectedCam) {
        const updatedSelectedCam = details.RouteDetail.Cam_Details.find(
          (cam) => cam.Cam === selectedCam.Cam
        );
        if (updatedSelectedCam) {
          setSelectedCam(updatedSelectedCam);
          return;
        }
      }
      // Otherwise default to the first camera
      setSelectedCam(details.RouteDetail.Cam_Details[0]);
    }
  }, [details]);


  useEffect(() => {
    // Reset player state when camera changes
    setCurrentlyPlayingSegment(null);
    setIsLoading(false);
    setLoadingMsg("");
    setPreloadedUrls({});
    if (pollingIntervalRef.current) {
      clearInterval(pollingIntervalRef.current);
      pollingIntervalRef.current = null;
    }

    details?.RouteDetail?.Cam_Details?.map((item) => {
      if (selectedCam?.Cam === item?.Cam) {
        let rtspurl = (item?.rtsp).split(":");
        setPlayerSrc({ url: rtspurl.slice(0, 3).join(":") + `:${item?.rtspport}` + ((item?.rtsp).split(":")).slice(3).join(":"), t: Date.now() });
      }
    })
  }, [selectedCam?.Cam]);

  const livestream = async () => {
    console.log("livestream");

    setCurrentlyPlayingSegment(null);
    if (!selectedCam?.Cam) return;
    
    setIsLoading(true);
    setLoadingMsg("Loading Live Stream...");

    let dateStr = moment().format('YYYYMMDD');
    const apiPath = `apiv2/apis/H264Playback2.php?sid=${encodeURIComponent(sid)}&camid=${encodeURIComponent(selectedCam.Cam)}&fid=live&date=${encodeURIComponent(dateStr)}`;

    try {
      const data = await get(apiPath);
      
      if (data?.error) {
         const errMsg = typeof data.error === 'string' ? data.error : (data.error?.msg || "Failed to load live stream");
         toastr.error(errMsg);
         setIsLoading(false);
         setLoadingMsg("");
         return;
      }
      
      const responseData = data?.OK?.data;
      let hlsUrl = null;

      if (typeof responseData === 'string') {
        hlsUrl = responseData;
      } else if (Array.isArray(responseData)) {
        hlsUrl = responseData[1]?.hls_url || responseData[0]?.hls_url;
      } else if (responseData?.hls_url) {
        hlsUrl = responseData.hls_url;
      }
      
      if (hlsUrl) {
          setPlayerSrc({ url: hlsUrl, t: Date.now() });
      } else {
          toastr.error(data?.OK?.msg || "Failed to load live stream");
      }
      setIsLoading(false);
      setLoadingMsg("");
      
    } catch (error) {
       console.error("Error fetching live url", error);
       setIsLoading(false);
       setLoadingMsg("");
       toastr.error("Failed to load live stream");
    }
  };

  const initStreamedian = () => {
    try {
      const streamedianPlayer = window.Streamedian.player('all_in_one_player', {
        bufferDuration: 30,
        socket: "wss://cam.remotedrishtee.com/ws/",
        redirectNativeMediaErrors: true,
        continuousFileLength: 180000,
        eventFileLength: 10000,
        errorHandler: errHandler.bind(),
      });
    } catch (error) {
      console.log(error);
    }
  };

  const errHandler = (err) => {
    console.error(err.message);
    // alert(err.message);
  };



  // Find the segment at a given percentage position (searches active view data)
  const findSegmentAtPosition = useCallback((positionPercent) => {
    if (!activeTimelineData || activeTimelineData.length === 0) return null;

    for (const seg of activeTimelineData) {
      const segEnd = seg.left + seg.width;
      if (positionPercent >= seg.left && positionPercent <= segEnd) {
        return seg;
      }
    }
    return null;
  }, [activeTimelineData]);

  // Handle mouse down on indicator
  const handleIndicatorMouseDown = (e) => {
    e.preventDefault();
    setIsDragging(true);
  };

  // Handle mouse move for dragging
  const handleMouseMove = useCallback((e) => {
    if (!isDragging || !timelineRef.current) return;

    const rect = timelineRef.current.getBoundingClientRect();
    let newPosition = ((e.clientX - rect.left) / rect.width) * 100;

    // Clamp position between 0 and 100
    newPosition = Math.max(0, Math.min(100, newPosition));
    setIndicatorPosition(newPosition);

    // Find and log the segment at this position
    const segment = findSegmentAtPosition(newPosition);
    if (segment) {
      console.log('Current segment:', {
        start: segment.start.format('DD-MMM-YYYY HH:mm'),
        end: segment.end.format('DD-MMM-YYYY HH:mm'),
        status: segment.status,
        filename: segment.filename,
        position: newPosition.toFixed(2) + '%'
      });
    }
  }, [isDragging, findSegmentAtPosition]);

  // Handle mouse up to stop dragging
  const handleMouseUp = useCallback(() => {
    if (isDragging) {
      setIsDragging(false);

      // Log final segment position
      const segment = findSegmentAtPosition(indicatorPosition);
      if (segment) {
        console.log('Indicator dropped on segment:', {
          start: segment.start.format('DD-MMM-YYYY HH:mm'),
          end: segment.end.format('DD-MMM-YYYY HH:mm'),
          status: segment.status,
          filename: segment.filename,
          position: indicatorPosition.toFixed(2) + '%'
        });
      } else {
        console.log('Indicator dropped at position:', indicatorPosition.toFixed(2) + '% (no segment)');
        // No segment found - stop video and show snapshot
        if (videoRef.current) {
          videoRef.current.pause();
          videoRef.current.currentTime = 0;
        }
        setPlayerSrc(null);
        setCurrentlyPlayingSegment(null);
        setIsLoading(false);
      }
    }
  }, [isDragging, indicatorPosition, findSegmentAtPosition]);

  // Add and remove event listeners for dragging
  useEffect(() => {
    if (isDragging) {
      document.addEventListener('mousemove', handleMouseMove);
      document.addEventListener('mouseup', handleMouseUp);
    }
    return () => {
      document.removeEventListener('mousemove', handleMouseMove);
      document.removeEventListener('mouseup', handleMouseUp);
    };
  }, [isDragging, handleMouseMove, handleMouseUp]);

  useEffect(() => {
    if (liveCameras) {
      let liveRoute = liveCameras?.data?.filter(item => item.live.bus === selectedCam?.Cam);
      if (liveRoute?.length > 0) {
        setliveStatus(true);
      } else {
        setliveStatus(false);
      }
    } else {
      setliveStatus(false);
    }
  }, [liveCameras, details, selectedCam?.Cam])


  //Snapshot 
  const files = useSelector(state => state.Data_Table.files);
  const group = useSelector(state => state.Active_Store?.sub_group)

  toastr.options = {
    positionClass: "toast-top-center",
    progressBar: "progressBar",
    showEasing: "swing",
    hideEasing: "linear",
    showMethod: "slideDown",
    hideMethod: "slideUp",
    timeOut: 2000,
  };
  const takeSnapshot = () => {
    toastr.success("Request sent")
    if (macAddress) {
      let queryParam = {
        sid: sid,
        id: files?.length > 0 ? liveStatus ? 1 : 2 : 0,
        mac: selectedCam?.mac || macAddress,
        filename: files?.length > 0 ? files.toString() : "",
      }
      dispatch(getsnapshotData(queryParam, (response) => {
        if (response?.OK) {
          if (response.OK.data === null) {
            toastr.warning("Null Response")
          }
          else {
            toastr.success(response.OK.data)
          }
        }
        if (response?.error) {
          toastr.error(response.error.msg);
        }
      }));

      setTimeout(() => {
        console.log("5 sec ");
        let queryParams = {
          sid: sid,
          date: startDate,
          enddate: endDate,
          route: route,
          higroup: group,
        }
        dispatch(getDetailData(queryParams));
      }, 5000);
      setPlayerSrc(null);
      setIsLoading(false);
      setLoadingMsg("");
      setCurrentlyPlayingSegment(null);
    }
  }


  //handle sources change
  useEffect(() => {
    const video = videoRef.current;
    if (!video) return;

    // Read the URL from the object safely
    const currentUrl = typeof playerSrc === 'object' && playerSrc !== null ? playerSrc.url : playerSrc;

    if (!currentUrl) {
      if (hlsRef.current) {
        hlsRef.current.destroy();
        hlsRef.current = null;
      }
      video.removeAttribute('src');
      video.load();
      return;
    }

    if (hlsRef.current) {
      hlsRef.current.destroy();
      hlsRef.current = null;
    }

    // Clear the video element's source to reset any unrecoverable state/errors
    video.removeAttribute('src');
    video.load();

    video.playbackRate = playbackSpeed;

    const attemptPlay = () => {
      video.play().catch(err => {
        video.muted = true;
        video.play().catch(e => console.error('Play failed:', e));
      });
    };

    if (Hls.isSupported()) {
      const hls = new Hls({ maxMaxBufferLength: 10 });
      hlsRef.current = hls;

      hls.loadSource(currentUrl); // Use currentUrl here
      hls.attachMedia(video);

      hls.on(Hls.Events.MANIFEST_PARSED, () => attemptPlay());
    } else if (video.canPlayType('application/vnd.apple.mpegurl')) {
      video.src = currentUrl; // Use currentUrl here
      video.addEventListener('loadedmetadata', attemptPlay);
    }

    return () => {
      if (hlsRef.current) hlsRef.current.destroy();
      video?.removeEventListener('loadedmetadata', attemptPlay);
    };
    // Keep playerSrc as a dependency; React will trigger because the object/timestamp changed!
    // Including playbackSpeed here would destroy & re-create the HLS stream on every speed change.
  }, [playerSrc]);

  const visibleDates = useMemo(() => {
    const visibleStartPct = panOffset;
    const visibleEndPct = panOffset + (100 / zoomLevel);

    if (timelineViewMode === 'hoursPlayed') {
      if (!activeTimelineData || activeTimelineData.length === 0) {
        return { startStr: '--', endStr: '--' };
      }
      
      let startSeg = activeTimelineData.find(seg => (seg.left + seg.width) >= visibleStartPct);
      if (!startSeg) startSeg = activeTimelineData[activeTimelineData.length - 1];

      let endSeg = [...activeTimelineData].reverse().find(seg => seg.left <= visibleEndPct);
      if (!endSeg) endSeg = activeTimelineData[0];

      let startDateStr, endDateStr;

      if (visibleStartPct <= startSeg.left) {
         startDateStr = startSeg.start.format('DD MMM YYYY HH:mm');
      } else {
         const segProgress = (visibleStartPct - startSeg.left) / startSeg.width;
         const durMs = startSeg.end.diff(startSeg.start);
         startDateStr = startSeg.start.clone().add(segProgress * durMs, 'ms').format('DD MMM YYYY HH:mm');
      }

      if (visibleEndPct >= endSeg.left + endSeg.width) {
         endDateStr = endSeg.end.clone().add(1, 'minutes').format('DD MMM YYYY HH:mm');
      } else {
         const segProgress = (visibleEndPct - endSeg.left) / endSeg.width;
         const durMs = endSeg.end.diff(endSeg.start);
         endDateStr = endSeg.start.clone().add(segProgress * durMs, 'ms').format('DD MMM YYYY HH:mm');
      }

      return { startStr: startDateStr, endStr: endDateStr };

    } else {
      const start = startDate ? moment(startDate).startOf('day') : moment().startOf('day');
      const end = endDate ? moment(endDate).endOf('day') : start.clone().endOf('day');
      if (end.isBefore(start)) end.add(1, 'day');
      const totalDuration = end.diff(start);

      const visibleStartDate = start.clone().add((visibleStartPct / 100) * totalDuration, 'ms');
      const visibleEndDate = start.clone().add((visibleEndPct / 100) * totalDuration, 'ms');

      return { 
        startStr: visibleStartDate.format('DD MMM YYYY HH:mm'), 
        endStr: visibleEndDate.format('DD MMM YYYY HH:mm') 
      };
    }
  }, [panOffset, zoomLevel, timelineViewMode, activeTimelineData, startDate, endDate]);

  return (
    <Card >
      <CardBody>
        <Row className="mb-3">
          <Col sm={12}>
            <Dropdown
              isOpen={singlebtn}
              toggle={() => setSinglebtn(!singlebtn)}
            >
              <DropdownToggle className="btn btn-secondary" caret>
                {selectedCam ? `${selectedCam.Cam} ` : "Select Camera"} <i className="mdi mdi-chevron-down" />
              </DropdownToggle>
              <DropdownMenu>
                {details?.RouteDetail?.Cam_Details?.map((cam, index) => (
                  <DropdownItem key={index} onClick={() => setSelectedCam(cam)}>
                    {cam.Cam}
                  </DropdownItem>
                ))}
              </DropdownMenu>
            </Dropdown>
          </Col>
        </Row>
        <Row>
          <Col xs="auto" className="d-flex flex-column gap-2" style={{ gap: '10px' }}>
            <button type="button" className="btn btn-sm btn-primary py-1 px-2" title="Snapshot" onClick={role.includes(29) ? takeSnapshot : null} style={{ cursor: role.includes(29) ? 'pointer' : 'default', fontSize: '11px' }}>
              <i className="mdi mdi-camera font-size-10"></i>
            </button>
            <button type="button" className="btn btn-sm btn-secondary py-1 px-2" title="Live" onClick={role.includes(28) && liveStatus ? livestream : null} style={{ cursor: role.includes(28) && liveStatus ? 'pointer' : 'default', fontSize: '11px' }}>
              <i className="mdi mdi-video font-size-12" />
            </button>
            <button type="button" className="btn btn-sm btn-danger py-1 px-2" title="Recording" style={{ fontSize: '11px' }}>
              <i className="mdi mdi-record-rec font-size-12"></i>
            </button>
          </Col>
          <Col>
            <div>
              <div style={{ position: 'relative', width: "100%", height: "400px", backgroundColor: "#000", overflow: "hidden" }}>
                {selectedCam && (
                  <div style={{
                    position: 'absolute',
                    top: '10px',
                    left: '10px',
                    color: 'white',
                    backgroundColor: 'rgba(0,0,0,0.5)',
                    padding: '2px 8px',
                    borderRadius: '4px',
                    zIndex: 5,
                    fontSize: '11px'
                  }}>
                    {selectedCam.Cam} | MAC: {selectedCam.mac}
                  </div>
                )}
                <video
                  ref={videoRef}
                  id="all_in_one_player"
                  // key={playerSrc || selectedCam?.buspic}
                  controls
                  muted
                  poster={selectedCam?.buspic}
                  style={{ width: "100%", height: "100%", objectFit: "contain" }}
                  autoPlay={true}
                  crossOrigin="anonymous"
                // src={playerSrc}
                >

                </video>

                {isLoading && (
                  <div style={{
                    position: 'absolute',
                    top: 0,
                    left: 0,
                    right: 0,
                    bottom: 0,
                    backgroundColor: 'rgba(0,0,0,0.7)',
                    display: 'flex',
                    alignItems: 'center',
                    justifyContent: 'center',
                    color: 'white',
                    zIndex: 10,
                    flexDirection: 'column'
                  }}>
                    <div className="spinner-border text-light mb-2" role="status">
                    </div>
                    <div>{loadingMsg}</div>
                  </div>
                )}

              </div>

            </div>
          </Col>
        </Row>
        {role.includes(8) && timelineData && timelineData.length > 0 && (
          <Row>
            <Col>
              <div className="mt-3">
                {/* Timeline Controls Bar */}
                <div className="d-flex justify-content-between align-items-center mb-2" style={{ gap: '10px' }}>
                  {/* View Mode Toggle */}
                  <div className="d-flex align-items-center" style={{ gap: '2px' }}>
                    <button
                      className={`btn btn-sm ${timelineViewMode === '24/7' ? 'btn-primary' : 'btn-outline-secondary'}`}
                      onClick={() => { setTimelineViewMode('24/7'); setIndicatorPosition(0); setZoomLevel(1); setPanOffset(0); }}
                      style={{ padding: '2px 8px', fontSize: '11px' }}
                    >24/7</button>
                    <button
                      className={`btn btn-sm ${timelineViewMode === 'hoursPlayed' ? 'btn-primary' : 'btn-outline-secondary'}`}
                      onClick={() => { setTimelineViewMode('hoursPlayed'); setIndicatorPosition(0); setZoomLevel(1); setPanOffset(0); }}
                      style={{ padding: '2px 8px', fontSize: '11px' }}
                    >Hours Played</button>
                  </div>

                  {/* Zoom Controls */}
                  <div className="d-flex align-items-center" style={{ gap: '5px' }}>
                    <button
                      className="btn btn-sm btn-outline-secondary"
                      onClick={handleZoomOut}
                      disabled={zoomLevel <= 1}
                      title="Zoom Out"
                    >
                      <i className="mdi mdi-magnify-minus" />
                    </button>
                    <span style={{ fontSize: '11px', minWidth: '70px', textAlign: 'center', fontWeight: '500' }}>
                      {zoomInfo.displayText}
                    </span>
                    <button
                      className="btn btn-sm btn-outline-secondary"
                      onClick={handleZoomIn}
                      disabled={zoomLevel >= maxZoomLevel}
                      title={`Zoom In (max: 1 hour)`}
                    >
                      <i className="mdi mdi-magnify-plus" />
                    </button>
                    {zoomLevel > 1 && (
                      <button
                        className="btn btn-sm btn-outline-secondary ms-1"
                        onClick={handleResetZoom}
                        title="Reset Zoom"
                      >
                        <i className="mdi mdi-refresh" />
                      </button>
                    )}
                  </div>

                  {/* Pan Controls (only visible when zoomed) */}
                  {zoomLevel > 1 && (
                    <div className="d-flex align-items-center" style={{ gap: '5px' }}>
                      <button
                        className="btn btn-sm btn-outline-secondary"
                        onClick={handlePanLeft}
                        disabled={panOffset <= 0}
                        title="Pan Left"
                      >
                        <i className="mdi mdi-chevron-left" />
                      </button>
                      <button
                        className="btn btn-sm btn-outline-secondary"
                        onClick={handlePanRight}
                        disabled={panOffset >= 100 - (100 / zoomLevel)}
                        title="Pan Right"
                      >
                        <i className="mdi mdi-chevron-right" />
                      </button>
                    </div>
                  )}

                  {/* Playback Speed Control */}
                  <div className="d-flex align-items-center" style={{ gap: '5px' }}>
                    <span style={{ fontSize: '11px', color: '#666' }}>Speed:</span>
                    {[0.5, 1, 1.5, 2].map(speed => (
                      <button
                        key={speed}
                        className={`btn btn-sm ${playbackSpeed === speed ? 'btn-primary' : 'btn-outline-secondary'}`}
                        onClick={() => handleSpeedChange(speed)}
                        style={{ padding: '2px 8px', fontSize: '11px' }}
                      >
                        {speed}x
                      </button>
                    ))}
                  </div>

                  {/* Legend */}
                  <div className="d-flex align-items-center" style={{ gap: '6px', fontSize: '10px' }}>
                    <div className="d-flex align-items-center" style={{ gap: '2px' }}>
                      <div style={{ width: '10px', height: '10px', backgroundColor: 'green', borderRadius: '2px' }} />
                      <span>Ready</span>
                    </div>
                    <div className="d-flex align-items-center" style={{ gap: '2px' }}>
                      <div style={{ width: '10px', height: '10px', backgroundColor: 'orange', borderRadius: '2px' }} />
                      <span>Pending</span>
                    </div>
                    <div className="d-flex align-items-center" style={{ gap: '2px' }}>
                      <div style={{ width: '10px', height: '10px', backgroundColor: 'red', borderRadius: '2px' }} />
                      <span>Error</span>
                    </div>
                    <div className="d-flex align-items-center" style={{ gap: '2px' }}>
                      <div style={{ width: '10px', height: '10px', backgroundColor: 'skyblue', borderRadius: '2px' }} />
                      <span>Downloaded</span>
                    </div>
                  </div>
                </div>

                {/* Timeline Container with Zoom/Pan */}
                <div
                  ref={timelineContainerRef}
                  onMouseDown={handleTimelinePanStart}
                  style={{
                    overflow: 'hidden',
                    borderRadius: '4px',
                    width: '100%',
                    cursor: zoomLevel > 1 ? 'grab' : 'default',
                    userSelect: 'none'
                  }}
                >
                  <div
                    ref={timelineRef}
                    onClick={(e) => { if (!isPanDragging.current) handleTimelineClick(e); }}
                    style={{
                      position: 'relative',
                      width: `${100 * zoomLevel}%`,
                      height: '40px',
                      backgroundColor: '#2a2a2a',
                      borderRadius: '4px',
                      cursor: zoomLevel > 1 ? 'inherit' : 'pointer',
                      boxShadow: 'inset 0 1px 3px rgba(0,0,0,0.4)',
                      transform: `translateX(-${panOffset}%)`,
                      transition: isPanDragging.current || isDragging ? 'none' : 'transform 0.2s ease-out'
                    }}
                  >
                    {/* Time Markers */}
                    {activeTimeMarkers.map((marker, i) => (
                      <div
                        key={i}
                        style={{
                          position: 'absolute',
                          left: `${marker.position}%`,
                          top: 0,
                          height: '100%',
                          display: 'flex',
                          flexDirection: 'column',
                          alignItems: 'center',
                          pointerEvents: 'none'
                        }}
                      >
                        <div style={{
                          width: '1px',
                          height: '8px',
                          backgroundColor: '#666'
                        }} />
                        <span style={{
                          fontSize: '8px',
                          color: '#888',
                          marginTop: '1px',
                          whiteSpace: 'nowrap'
                        }}>
                          {marker.label}
                        </span>
                      </div>
                    ))}

                    {/* Buffer Indicator (lighter background) */}
                    <div
                      style={{
                        position: 'absolute',
                        top: '50%',
                        left: 0,
                        width: `${bufferedPercent}%`,
                        height: '6px',
                        backgroundColor: 'rgba(255,255,255,0.2)',
                        transform: 'translateY(-50%)',
                        borderRadius: '3px',
                        pointerEvents: 'none'
                      }}
                    />

                    {/* Playback Progress Indicator */}
                    <div
                      style={{
                        position: 'absolute',
                        top: '50%',
                        left: 0,
                        width: `${Math.min(indicatorPosition, 100)}%`,
                        height: '6px',
                        backgroundColor: 'rgba(255,68,68,0.4)',
                        transform: 'translateY(-50%)',
                        borderRadius: '3px',
                        pointerEvents: 'none',
                        transition: isDragging ? 'none' : 'width 0.2s linear'
                      }}
                    />

                    {/* Background track line */}
                    <div
                      style={{
                        position: 'absolute',
                        top: '50%',
                        left: 0,
                        right: 0,
                        height: '4px',
                        backgroundColor: '#444',
                        transform: 'translateY(-50%)',
                        borderRadius: '2px'
                      }}
                    />

                    {/* Segments as horizontal bars */}
                    {activeTimelineData.map((seg, i) => (
                      <div
                        key={i}
                        data-segment="true"
                        title={`${seg.start.format('DD-MMM HH:mm')} - ${seg.end.format('HH:mm')} `}
                        style={{
                          position: 'absolute',
                          left: `${seg.left}%`,
                          width: `${Math.max(seg.width, 0.1)}%`,
                          height: '30px',
                          top: '50%',
                          transform: 'translateY(-50%)',
                          backgroundColor: setColor(seg.status),
                          borderRadius: '6px',
                          cursor: 'pointer',
                          transition: 'transform 0.1s, box-shadow 0.1s',
                          boxShadow: '0 1px 3px rgba(0,0,0,0.3)',
                          zIndex: 2
                        }}
                        onClick={(e) => {
                          e.stopPropagation();
                          handleSegmentClick(seg);
                        }}
                        onMouseEnter={(e) => {
                          e.currentTarget.style.transform = 'translateY(-50%) scaleY(1.1)';
                          e.currentTarget.style.boxShadow = '0 0 8px ' + setColor(seg.status);
                          setHoveredSegment(seg);
                          setHoverPosition({ x: e.clientX, y: e.clientY });
                        }}
                        onMouseLeave={(e) => {
                          e.currentTarget.style.transform = 'translateY(-50%) scaleY(1)';
                          e.currentTarget.style.boxShadow = '0 1px 3px rgba(0,0,0,0.3)';
                          setHoveredSegment(null);
                        }}
                      />
                    ))}

                    {/* Hover Preview Tooltip */}
                    {hoveredSegment && (
                      <div
                        style={{
                          position: 'fixed',
                          left: hoverPosition.x + 10,
                          top: hoverPosition.y - 80,
                          backgroundColor: 'rgba(0,0,0,0.9)',
                          color: '#fff',
                          padding: '8px 12px',
                          borderRadius: '6px',
                          fontSize: '11px',
                          zIndex: 1000,
                          pointerEvents: 'none',
                          boxShadow: '0 4px 12px rgba(0,0,0,0.4)'
                        }}
                      >
                        <div style={{ fontWeight: 'bold', marginBottom: '4px', color: setColor(hoveredSegment.status) }}>
                          {hoveredSegment.status === 'R' ? '✓ Ready' : hoveredSegment.status === 'O' ? '⏳ Pending' : hoveredSegment.status === 'E' ? '✗ Error' : 'Downloaded'}
                        </div>
                        <div>{hoveredSegment.start.format('DD-MMM HH:mm')} - {hoveredSegment.end.clone().add(1, 'minutes').format('HH:mm')}</div>
                        <div style={{ fontSize: '10px', color: '#aaa', marginTop: '2px' }}>{hoveredSegment.filename}</div>
                      </div>
                    )}

                    {/* Draggable Indicator */}
                    {/* Draggable Indicator */}
                    <div
                      data-indicator="true"
                      onMouseDown={handleIndicatorMouseDown}
                      onMouseEnter={() => setShowTooltip(true)}
                      onMouseLeave={() => !isDragging && setShowTooltip(false)}
                      style={{
                        position: 'absolute',
                        left: `${indicatorPosition}%`,
                        top: '50%',
                        transform: 'translate(-50%, -50%)',
                        width: '2px', // Thin line
                        height: '40px', // Full height
                        backgroundColor: '#fff', // White line
                        cursor: isDragging ? 'grabbing' : 'grab',
                        zIndex: 15,
                        boxShadow: isDragging ? '0 0 4px rgba(255,255,255,0.8)' : 'none',
                        transition: isDragging ? 'none' : 'left 0.2s linear'
                      }}
                    >
                      {/* Top Time Label */}
                      <div
                        style={{
                          position: 'absolute',
                          top: '-32px', // Position above the track
                          left: '50%',
                          transform: 'translateX(-50%)',
                          backgroundColor: '#6c5ce7', // Purple shade
                          color: '#fff',
                          padding: '4px 8px',
                          borderRadius: '4px',
                          fontSize: '11px',
                          fontWeight: 'bold',
                          whiteSpace: 'nowrap',
                          boxShadow: '0 2px 4px rgba(0,0,0,0.3)',
                        }}
                      >
                        {(() => {
                          if (timelineViewMode === 'hoursPlayed') {
                            // In Hours Played mode, derive time from the active segment
                            const seg = currentIndicatorSegment;
                            if (seg) {
                              // Calculate position within this segment
                              const segProgress = seg.width > 0 ? (indicatorPosition - seg.left) / seg.width : 0;
                              const segDurationMs = seg.end.diff(seg.start);
                              const offsetMs = segProgress * segDurationMs;
                              return seg.start.clone().add(offsetMs, 'ms').format('HH:mm:ss');
                            }
                            return '--:--:--';
                          }
                          const start = startDate ? moment(startDate).startOf('day') : moment().startOf('day');
                          const end = endDate ? moment(endDate).endOf('day') : start.clone().endOf('day');
                          if (end.isBefore(start)) end.add(1, 'day');
                          const totalDuration = end.diff(start);
                          const ms = (indicatorPosition / 100) * totalDuration;
                          return start.clone().add(ms).format('HH:mm:ss');
                        })()}

                        {/* Arrow for label */}
                        <div
                          style={{
                            position: 'absolute',
                            bottom: '-4px',
                            left: '50%',
                            transform: 'translateX(-50%)',
                            width: 0,
                            height: 0,
                            borderLeft: '4px solid transparent',
                            borderRight: '4px solid transparent',
                            borderTop: '4px solid #6c5ce7'
                          }}
                        />
                      </div>

                      {/* Bottom Handle */}
                      <div
                        style={{
                          position: 'absolute',
                          bottom: '-6px',
                          left: '50%',
                          transform: 'translateX(-50%)',
                          width: '14px',
                          height: '14px',
                          backgroundColor: '#fff',
                          borderRadius: '50%',
                          border: '4px solid #6c5ce7', // Purple center effect (thick border)
                          boxShadow: '0 2px 4px rgba(0,0,0,0.4)',
                        }}
                      />
                    </div>
                  </div>
                </div>

                {/* Time Labels */}
                <div className="d-flex justify-content-between align-items-center" style={{ fontSize: '10px', marginTop: '4px', color: '#666' }}>
                  <span>
                    {visibleDates.startStr}
                  </span>
                  <span style={{ fontWeight: 'bold', color: '#333' }}>
                    {currentIndicatorSegment ? currentIndicatorSegment.start.format('HH:mm') : '--:--'}
                  </span>
                  <span>
                    {visibleDates.endStr}
                  </span>
                </div>
              </div>
            </Col>
          </Row>
        )}
      </CardBody>
    </Card>
  );
}

export default PlayerCard;
